import React from 'react'
import LinearProgress from '@mui/material/LinearProgress';
import styled from 'styled-components'
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';
import { Bar } from 'react-chartjs-2';
ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

export const options = {
  elements: {
    bar: {
      borderWidth: 2,
    },
  },
  responsive: true,
  plugins: {
    legend: {
      position: 'top',
      labels: {
        color: "white",
        font: {
          size: 12
        }
      }
    },
  },
  scales: {
    x: {
      ticks: {
        color: 'white'  // Color for x-axis tick labels
      },
    },
    y: {
      ticks: {
        color: 'white'  // Color for y-axis tick labels
      },
    }
  },
};

const labels = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];

const LoadingBanner = styled.div`
  height: 100%;
  width: 100%;

  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;

  font-size: 3rem;
`
export default function WeeklyGraph({ weeklyData = {}, category="" }) {

    // For linear progress
    const [progress, setProgress] = React.useState(0);

    React.useEffect(() => {
      const timer = setInterval(() => {
        setProgress((oldProgress) => {
          if (oldProgress === 100) {
            return 0;
          }
          const diff = Math.random() * 10;
          return Math.min(oldProgress + diff, 100);
        });
      }, 500);
  
      return () => {
        clearInterval(timer);
      };
    }, []);
    //
  const [loading, setLoading] = React.useState(true);
  const [dataList, setDataList] = React.useState([]);
  React.useEffect(() => {
    if (Object.keys(weeklyData).length > 0) {
      if (category === "Hours") {
        let totalDataList = Object.values(weeklyData).map(item => item.totalHours);
        setDataList(totalDataList);
        setLoading(false);
      }
      else if (category === "Employees") {
        let totalDataList = Object.values(weeklyData).map(item => item.uniqueWorkers);
        setDataList(totalDataList);
        setLoading(false);
      }
    }
  }, [weeklyData]);

  function getColor(category) {
    let colors = {
      borderColor: 'rgb(201, 203, 207)',
      backgroundColor: 'rgba(201, 203, 207, 0.5)',
    };
  
    if (category === "Hours") {
      colors = {
        borderColor: 'rgb(255, 99, 132)',
        backgroundColor: 'rgba(255, 99, 132, 0.5)',
      };
    } else if (category === "Employees") {
      colors = {
        borderColor: 'rgb(75, 192, 192)',
        backgroundColor: 'rgba(75, 192, 192, 0.5)',
      };
    } else if (category === "Assets") {
      colors = {
        borderColor: 'rgb(255, 206, 86)',
        backgroundColor: 'rgba(255, 206, 86, 0.5)',
      };
    }
  
    return colors;
  }

  const { borderColor, backgroundColor } = getColor(category);

  const data = {
    labels,
    datasets: [
      {
        label: category,
        data: dataList,
        borderColor: borderColor,
        backgroundColor: backgroundColor,
      },
    ],
  };

  return (
    <>
      {loading ? (
        <LoadingBanner>
          <div>Loading Data...</div>
          <LinearProgress 
            variant="determinate" 
            value={progress} 
            sx={{
              width: '100%', background: "black", 
              '& .MuiLinearProgress-bar': {
                backgroundColor: '#6C7A89',
              },
            }} />
          
        </LoadingBanner>
      ) : (
        <Bar options={options} data={data} />
      )}
    </>
  );
}